import { AuthorityWithState as Authority, RouteGuard } from './Authority';

export { RouteGuard };
export default Authority;